enum NotificationStatus {
  READED = 'READED',
  CREATED = 'CREATED',
}

export { NotificationStatus };
